function floatToString(t, o) {
    var r = t.toFixed(o).toString();
    return r.match(/^\.\d+/) ? "0" + r : r
}

function attributeToString(t) {
    return "string" != typeof t && (t += "", "undefined" === t && (t = "")), jQuery.trim(t)
}
"undefined" == typeof Shopify && (Shopify = {}), Shopify.money_format = "$ {{amount}}", Shopify.onError = function(XMLHttpRequest, textStatus) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    alert(data.message + "(" + data.status + "): " + data.description)
}, Shopify.onCartUpdate = function(t) {
    alert("There are now " + t.item_count + " items in the cart.")
}, Shopify.onItemAdded = function(t) {
    alert(t.title + " was added to your shopping cart.")
}, Shopify.onProduct = function(t) {
    alert("Received everything we ever wanted to know about " + t.title)
}, Shopify.formatMoney = function(t, o) {
    var r = "",
        e = /\{\{\s*(\w+)\s*\}\}/,
        a = o || this.money_format;
    switch (a.match(e)[1]) {
        case "amount":
            r = floatToString(t / 100, 2).replace(/(\d+)(\d{3}[\.,]?)/, "$1 $2");
            break;
        case "amount_no_decimals":
            r = floatToString(t / 100, 0).replace(/(\d+)(\d{3}[\.,]?)/, "$1 $2");
            break;
        case "amount_with_comma_separator":
            r = floatToString(t / 100, 2).replace(/\./, ",").replace(/(\d+)(\d{3}[\.,]?)/, "$1.$2")
    }
    return a.replace(e, r)
}, Shopify.resizeImage = function(t, o) {
    try {
        if ("original" == o) return t;
        var r = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
        return r[1] + "_" + o + "." + r[2]
    } catch (e) {
        return t
    }
}, Shopify.addItem = function(t, o, r) {
    o = o || 1;
    var e = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + o + "&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onItemAdded(t)
        },
        error: function(t, o) {
            Shopify.onError(t, o)
        }
    };
    jQuery.ajax(e)
}, Shopify.addItemFromForm = function(t, o) {
    var r = {
        type: "POST",
        url: "/cart/add.js",
        data: jQuery(t).serialize(),
        dataType: "json",
        success: function(r) {
            "function" == typeof o ? o(r, t) : Shopify.onItemAdded(r, t);

            $('body').append('<div id="cart_added"><h4>Product added to cart</h4><div class="cart_added__row"><div class="cart_added__1" id="cart_added__img"><img src="" alt="" /></div><div class="cart_added__2"><span id="cart_added__name" class="product_name"></span><p id="cart_added__quantity">Quantity: <span></span></p><a class="btn" href="/cart">Go to cart</a><a class="btn btn-alt" id="cart_added__close" href="#">Continue shopping</a></div></div></div>');

            if ( r.title.length < 60 ) {
                var productTitle = r.title;
            }
            else {
                var productTitle = $.trim( r.title ).substring(0, 60) + '...';
            };

            $('#cart_added__name').html( productTitle );
            $('#cart_added__quantity span').html( r.quantity );
            $('#cart_added__close').on( 'click', function(e) {
                e.preventDefault();

                $('.fancybox-close').trigger('click');
            });

            $('#cart_added__img img').attr( 'src', r.image ).load( function() { 
                $.fancybox.open( $('#cart_added'),
                    {
                        'openSpeed': 500,
                        'closeSpeed': 300,
                        'afterClose': function() {
                            $('#cart_added').remove();
                        }
                    }
                );
            });

        },
        error: function(t, o) {
            Shopify.onError(t, o);

            var errorData = eval('(' + t.responseText + ')');

            $('body').append('<div id="cart_added" class="cart_error"><h4></h4><p class="alert alert-error"></p></div>');
            $('#cart_added h4').html( errorData.message );
            $('#cart_added p').html( errorData.description );

            $.fancybox.open( $('#cart_added'),
                {
                    'openSpeed': 500,
                    'closeSpeed': 300,
                    'afterClose': function() {
                        $('#cart_added').remove();
                    }
                }
            );

        }
    };
    jQuery.ajax(r)
}, Shopify.getCart = function(t) {
    jQuery.getJSON("/cart.js", function(o) {
        "function" == typeof t ? t(o) : Shopify.onCartUpdate(o)
    })
}, Shopify.getProduct = function(t, o) {
    jQuery.getJSON("/products/" + t + ".js", function(t) {
        "function" == typeof o ? o(t) : Shopify.onProduct(t)
    })
}, Shopify.changeItem = function(t, o, r) {
    var e = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + o + "&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, o) {
            Shopify.onError(t, o)
        }
    };
    jQuery.ajax(e)
}, Shopify.removeItem = function(t, o) {
    var r = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof o ? o(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, o) {
            Shopify.onError(t, o)
        }
    };
    jQuery.ajax(r)
}, Shopify.clear = function(t) {
    var o = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(o) {
            "function" == typeof t ? t(o) : Shopify.onCartUpdate(o)
        },
        error: function(t, o) {
            Shopify.onError(t, o)
        }
    };
    jQuery.ajax(o)
}, Shopify.updateCartFromForm = function(t, o) {
    var r = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery(t).serialize(),
        dataType: "json",
        success: function(r) {
            "function" == typeof o ? o(r, t) : Shopify.onCartUpdate(r, t)
        },
        error: function(t, o) {
            Shopify.onError(t, o)
        }
    };
    jQuery.ajax(r)
}, Shopify.updateCartAttributes = function(t, o) {
    var r = "";
    jQuery.isArray(t) ? jQuery.each(t, function(t, o) {
        var e = attributeToString(o.key);
        "" !== e && (r += "attributes[" + e + "]=" + attributeToString(o.value) + "&")
    }) : "object" == typeof t && null !== t && jQuery.each(t, function(t, o) {
        r += "attributes[" + attributeToString(t) + "]=" + attributeToString(o) + "&"
    });
    var e = {
        type: "POST",
        url: "/cart/update.js",
        data: r,
        dataType: "json",
        success: function(t) {
            "function" == typeof o ? o(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, o) {
            Shopify.onError(t, o)
        }
    };
    jQuery.ajax(e)
}, Shopify.updateCartNote = function(t, o) {
    var r = {
        type: "POST",
        url: "/cart/update.js",
        data: "note=" + attributeToString(t),
        dataType: "json",
        success: function(t) {
            "function" == typeof o ? o(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, o) {
            Shopify.onError(t, o)
        }
    };
    jQuery.ajax(r)
};